import React, { useEffect, useState } from 'react'
import Cookies from 'universal-cookie'

import { exlcusive, translated } from '../constants/data/exlcusive'

import useIsExlcusive from '../hooks/useIsExlcusive'

import { TitleS, BodyS } from '../styles/Typography'
import { LinkAsButtonGatsbyPrimary } from '../styles/components/LinkStyled'
import { ModalStyled, ModalOverlay, ModalContent } from '../styles/components/ModalStyled'

/**
 * The modal for exclusive countries.
 * @returns {FunctionComponent}
 */
export const ExclusiveDistributorModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const { isExlcusive, isTranslated, countryCode } = useIsExlcusive()

  const cookies = new Cookies()

  useEffect(() => {
    const isCookieSet = cookies.get('isExclusive')

    if ((isExlcusive || isTranslated) && !isCookieSet) {
      setIsOpen(true)
    }
  })

  const handleClick = () => {
    cookies.set('isExclusive', 'true', { maxAge: 3600 })
    setIsOpen(false)
  }

  const translatedAndExlcusive = { ...translated, ...exlcusive }

  return (
    <ModalStyled isOpen={isOpen}>
      <ModalOverlay onClick={() => setIsOpen(false)} />
      <ModalContent maxWidth="600px">
        <TitleS className="title">{translatedAndExlcusive[countryCode]?.title}</TitleS>
        <LinkAsButtonGatsbyPrimary className="btn" to={translatedAndExlcusive[countryCode]?.link ?? '/'} onClick={handleClick}>
          {translatedAndExlcusive[countryCode]?.btn_redirect}
        </LinkAsButtonGatsbyPrimary>
        <BodyS className="link" onClick={handleClick}>
          {translatedAndExlcusive[countryCode]?.btn_close}
        </BodyS>
      </ModalContent>
    </ModalStyled>
  )
}

export default ExclusiveDistributorModal
